import script from "./sidebarAdvancedFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebarAdvancedFilters.vue?vue&type=script&setup=true&lang=js"

import "./sidebarAdvancedFilters.vue?vue&type=style&index=0&id=027bfa9a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027bfa9a"]])

export default __exports__